/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import {
  createEmptyStateResource,
  createStateResource,
  getEmbeddedResources,
  isNotNil,
  StateResource,
} from '@common/tech-shared';
import { SettingListLinkRel } from './settings.linkrel';
import { SettingItemResource, SettingListResource, SettingName } from './settings.model';

export function getSettingItemResource<T>(
  settingsListResource: StateResource<SettingListResource>,
  itemName: SettingName,
): StateResource<SettingItemResource<T>> {
  const entries: SettingItemResource<T>[] = getEmbeddedResources(settingsListResource, SettingListLinkRel.LIST);
  const entry: SettingItemResource<T> = entries.find((item: SettingItemResource<T>) => item.name === itemName);
  return isNotNil(entry) ? createStateResource(entry) : createEmptyStateResource<SettingItemResource<T>>();
}
